module.exports = __webpack_public_path__ + "img/markdown.3dfdbe2d.svg";